import React, { useState, useEffect } from "react";
import Input from "./../../../../shared/Input/Input";
import { brandFromNumber } from "../../../shared/credit-card-util";
import {
	isAllFieldsEmpty,
	getUserToken,
	validCreditCardDate,
	scrollToComponent
} from "../../../shared/utils";
import Checkbox from "./../../../../shared/Checkbox/Checkbox";
import {
	sendCreateUpdateCreditCard,
	getUserCreditCard,
	deleteUserCreditCard
} from "../../../shared/requests-api";
import Modal from "../../../../shared/Modal/Modal";
import Button from "../../../../shared/button/button";
import Loading from "../../../../shared/Loading/Loading";
import { CreditCardsRelation } from "../../../shared/enums";
import { ROUTE_HOME } from "./../../../shared/constants";
import { isMobile } from "./../../../../../js/components/searchform/utils/common";
import { validateCPF } from "../../../../../js/shared/validation-utils";
import { validateCNPJ } from "./../../../shared/utils";
import { useNewOffer } from "../../../context/new-offer";

function AccountCreditCard() {
	const [state, setState] = useState({
		errors: {
			name: undefined,
			cpf: undefined,
			securityCode: undefined,
			validDate: undefined,
			number: undefined
		}
	});
	const [loading, setLoading] = useState(false);
	const [showDelete, setShowDelete] = useState(false);
	const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
	const [sending, setSending] = useState(false);
	const [showSucesso, setShowSucesso] = useState(false);
	const [notFound, setNotFound] = useState(false);
	const [showBrandInvalid, setShowBrandInvalid] = useState(false);
	const [showDeleteNotFound, setShowDeleteNotFound] = useState(false);
	const [card, setCard] = useState(undefined);

	const { fetchCreditCardData } = useNewOffer();

	useEffect(() => {
		setLoading(true);
		getUserCreditCard(getUserToken())
			.then(response => {
				const { name, number, validDate, securityCode, brand, cpf } = response.data;

				let errors = state.errors;

				errors.cpf = "";
				errors.name = "";
				errors.number = "";
				if (validCreditCardDate(validDate)) {
					errors.validDate = "";
				} else {
					errors.validDate = "Data inválida";
				}
				errors.securityCode = "";

				setState({
					...state,
					cpf,
					name,
					oldNumber: "**** **** **** " + number,
					number: "**** **** **** " + number,
					validDate,
					securityCode,
					errors
				});
				setCard(CreditCardsRelation[brand]);
				setLoading(false);
			})
			.catch(response => {
				setNotFound(true);
				setLoading(false);
			});
	}, []);

	const deleteFn = () => {
		if (notFound) {
			setShowDeleteNotFound(true);
		} else {
			setShowDelete(true);
		}
	};

	const confirmDelete = () => {
		setShowDelete(false);
		deleteUserCreditCard(getUserToken())
			.then(response => {
				fetchCreditCardData();
				setShowDeleteSuccess(true);
				setNotFound(true);
				setCard(undefined);
				setState({
					...state,
					name: "",
					number: "",
					validDate: "",
					securityCode: "",
					cpf: "",
					errors: []
				});
			})
			.catch(err => {
				console.log(err);
			});
	};

	const confirmSave = () => {
		const { card, name, cpf, securityCode, validDate, number, errors } = state;
		if (!isValid()) {
			if (card == "" || card == undefined) {
				errors.card = "Campo obrigatório";
			}
			if (name == "" || name == undefined) {
				errors.name = "Campo obrigatório";
			}
			if (cpf == "" || cpf == undefined) {
				errors.cpf = "Campo obrigatório";
			}
			if (securityCode == "" || securityCode == undefined) {
				errors.securityCode = "Campo obrigatório";
			}
			if (validDate == "" || validDate == undefined) {
				errors.validDate = "Campo obrigatório";
			}
			if (number == "" || number == undefined) {
				errors.number = "Campo obrigatório";
			}
			setState({ ...state, errors });
		} else {
			save();
		}
	};

	const save = () => {
		const token = getUserToken();
		const { name, oldNumber, number, validDate, securityCode, cpf } = state;

		let numberFmt = String(number).replace(/[^0-9.]/g, "");
		let oldNumberFmt = String(oldNumber).replace(/[^0-9.]/g, "");

		if (numberFmt == oldNumberFmt) {
			numberFmt = undefined;
		}

		setSending(true);
		sendCreateUpdateCreditCard(token, name, numberFmt, validDate, securityCode, cpf)
			.then(response => {
				fetchCreditCardData();
				setSending(false);
				setShowSucesso(true);
				setNotFound(false);
				setShowBrandInvalid(false);
			})
			.catch(response => {
				setSending(false);
				setShowSucesso(false);
				setShowBrandInvalid(true);
			});
	};

	const validForm = event => {
		const { errors } = state;
		let value = event.target.type == "checkbox" ? event.target.checked : event.target.value;

		if (event.target.name == "name") {
			value = value.replace(/[0-9]/g, "");
		}

		errors[event.target.name] = value
			? ""
			: `${event.target.title || event.target.name} não confere`;

		if (event.target.name == "cpf" && event.target.value) {
			let length = event.target.value.length;
			let isCPFValid = validateCPF(event.target.value);
			let isCNPJValid = validateCNPJ(event.target.value);
			if (length < 14) {
				errors.cpf = "CPF inválido";
			} else if (length == 14 && isCPFValid == false) {
				errors.cpf = "CPF inválido";
			} else if (length > 14 && length < 18) {
				errors.cpf = "CNPJ inválido";
			} else if (length == 18 && isCNPJValid == false) {
				errors.cpf = "CNPJ inválido";
			}
		}

		if (event.target.name == "number") {
			value = value.replace(/\D/g, "");
		}

		if (event.target.name == "securityCode") {
			if (event.target.value.length < 3) {
				errors.securityCode = "Código de segurança inválido.";
			}
		}

		if (event.target.name == "validDate") {
			if (validCreditCardDate(event.target.value)) {
				errors.validDate = "";
			} else {
				errors.validDate = "Data inválida";
			}
		}

		setState({ ...state, [event.target.name]: value, errors });
	};

	const isValid = () => {
		const { name, cpf, securityCode, validDate, number, errors } = state;

		return (
			name &&
			cpf &&
			securityCode &&
			validDate &&
			number &&
			isAllFieldsEmpty(errors, "name", "cpf", "securityCode", "validDate", "number")
		);
	};

	const searchBrand = num => {
		let card = brandFromNumber(num);
		setCard(card);
	};

	const { name, cpf, securityCode, validDate, number, errors, notInform } = state;
	const { innerWidth } = window;

	if (loading) {
		return (
			<div className="panel-content-component">
				<Loading />
			</div>
		);
	}

	return (
		<section className="account-credit-card panel-content-component row no-margin">
			<form className="form-offer block-center" onChange={validForm}>
				<div className="col-xs-16 text-center no-padding">
					<p className="account-credit-card--title">
						As informações do cartão serão utilizadas apenas para pagar a taxa de embarque na cia
						aérea. O valor da taxa de embarque será reembolsado junto com o valor das milhas
						vendidas.
					</p>
				</div>
				<div className="row">
					<div
						className="col-xs-16 col-md-7 card-number"
						onClick={isMobile() && (() => scrollToComponent(".card-number"))}
					>
						<Input
							label="Número do cartão"
							placeholder="Inserir número do cartão"
							maskpattern="9999 9999 9999 9999"
							name="number"
							required
							errorMessage={errors.number}
							value={number}
							pattern="\d*"
							inputMode="numeric"
							disabled={notInform}
							onChange={searchBrand}
							maskpattern={card && card.mask}
							data-action="account-credit-card-number"
						>
							{card && (
								<div
									className={`form-control-feedback cc-img cc-${card.brand}`}
									title={`Cartão ${card.brand}`}
								/>
							)}
						</Input>
					</div>
					<div
						className="col-xs-16 col-sm-8 col-md-5 valid-date"
						onClick={isMobile() && (() => scrollToComponent(".valid-date"))}
					>
						<Input
							label="Data de validade"
							placeholder="  /  "
							maskpattern="99/99"
							name="validDate"
							value={validDate}
							pattern="\d*"
							inputMode="numeric"
							errorMessage={errors.validDate}
							disabled={notInform}
							required
							data-action="account-credit-card-valid-date"
						/>
					</div>
					<div
						className="col-xs-16 col-sm-8 col-md-4 security-code"
						onClick={isMobile() && (() => scrollToComponent(".security-code"))}
					>
						<Input
							label="Código de segurança"
							tooltip="Código localizado no verso do cartão de crédito. Geralmente possui 3 ou 4 dígitos."
							tooltipDirection={innerWidth > 992 && innerWidth < 1417 ? "left" : "up"}
							placeholder=""
							name="securityCode"
							value={securityCode}
							pattern="\d*"
							inputMode="numeric"
							minLength="3"
							maxLength={card ? card.cvcLength[0] : 4}
							maskpattern="9999"
							errorMessage={errors.securityCode}
							disabled={notInform}
							required
							data-action="account-credit-card-security-code"
						/>
					</div>
					<div
						className="col-xs-16 col-md-10 holder-name"
						onClick={isMobile() && (() => scrollToComponent(".holder-name"))}
					>
						<Input
							label="Nome (exatamente como está no cartão)"
							placeholder="Nome do titular"
							name="name"
							value={name}
							disabled={notInform}
							errorMessage={errors.name}
							required
							data-action="account-credit-card-name"
						/>
					</div>
					<div
						className="col-xs-16 col-md-6 cpfcnpj-credit-card"
						onClick={isMobile() && (() => scrollToComponent(".cpfcnpj-credit-card"))}
					>
						<Input
							label="CPF/CNPJ"
							placeholder="Insira seu CPF ou CNPJ"
							maskpattern={["999.999.999-999", "99.999.999/9999-99"]}
							name="cpf"
							value={cpf}
							pattern="\d*"
							inputMode="numeric"
							disabled={notInform}
							errorMessage={errors.cpf}
							required
							data-action="account-credit-card-cpfcnpj"
						/>
					</div>
				</div>

				<div className="row row-botoes">
					<div className="col-xs-3 icon">
						<i className="icon-trash" onClick={deleteFn} data-action="account-credit-card-delete" />
					</div>
					<div className="col-xs-13 text-right">
						<Button
							className="btn btn-cancel"
							onClick={() => (window.location.href = ROUTE_HOME)}
							type="button"
							data-action="account-credit-card-cancel"
						>
							Cancelar
						</Button>
						<Button
							className={`btn btn-primary confirm-button ${sending ? "btn-loading" : ""}`}
							onClick={confirmSave}
							disabled={sending}
							type="button"
							data-action="account-credit-card-save"
						>
							{sending ? <Loading /> : "Salvar"}
						</Button>
					</div>
				</div>

				<Modal
					title="EXCLUIR CARTÃO DE CRÉDITO"
					description="Deseja realmente excluir os dados do seu cartão de crédito?"
					cancel="Fechar"
					confirm="Sim, excluir"
					show={showDelete}
					onCancel={() => setShowDelete(false)}
					onConfirm={confirmDelete}
				/>

				<Modal
					title="EXCLUÍDO COM SUCESSO"
					description="Seu cartão de crédito foi excluído com sucesso :)"
					confirm="Fechar"
					show={showDeleteSuccess}
					onCancel={() => setShowDeleteSuccess(false)}
					onConfirm={() => setShowDeleteSuccess(false)}
				/>

				<Modal
					title="BANDEIRA NÃO ENCONTRADA"
					description="Seu número de cartão de crédito não foi reconhecido como uma bandeira válida, informe corretamente."
					confirm="Fechar"
					show={showBrandInvalid}
					onCancel={() => setShowBrandInvalid(false)}
					onConfirm={() => setShowBrandInvalid(false)}
				/>

				<Modal
					title="NÃO ENCONTRADO"
					description="Não existe cartão de crédito cadastrado."
					confirm="Fechar"
					show={showDeleteNotFound}
					onCancel={() => setShowDeleteNotFound(false)}
					onConfirm={() => setShowDeleteNotFound(false)}
				/>

				<Modal
					title="DADOS ALTERADOS"
					description="Seus dados foram alterados com sucesso :)"
					confirm="Fechar"
					show={showSucesso}
					onCancel={() => setShowSucesso(false)}
					onConfirm={() => setShowSucesso(false)}
				/>
			</form>
		</section>
	);
}

export default AccountCreditCard;
